export default __webpack_public_path__ + "static/concerto-e1ba50878409dfa9ea85b4ae0e116b27.svg";